import type { DraftStatus } from '@/features/menu/utils/menu-draft';
import { useT } from '@/i18n';
import { Chip } from 'framework7-react';

export function DraftTag({ status, testId }: { status: DraftStatus; testId: string }) {
  const q = useT().menuQuickEdit;
  if (!status) return null;
  const text = status === 'new' ? q.tagNew : status === 'removed' ? q.tagRemoved : q.tagMoved;
  return (
    <Chip
      text={text}
      outline
      className={
        status === 'removed'
          ? 'quick-edit-tag quick-edit-tag--removed'
          : 'quick-edit-tag ai-changed-chip'
      }
      data-testid={testId}
    />
  );
}
